import type { IAvatarSize } from "@/ui-kit";
import type { IAvatarFonts } from "./types";

export const fontClassMap: Record<IAvatarSize, IAvatarFonts> = {
  xs: {
    letters: "nuco-typography--caption",
    title: "nuco-typography--caption",
    subtext: "nuco-typography--footnote light",
    skeletonImageSize: "1.5rem",
    skeletonTitleWidth: "6.25rem",
    skeletonTitleHeight: "0.875rem",
    skeletonSubtextWidth: "4.375rem",
    skeletonSubtextHeight: "0.875rem",
  },
  sm: {
    letters: "nuco-typography--body regular",
    title: "nuco-typography--body regular",
    subtext: "nuco-typography--caption light",
    skeletonImageSize: "2rem",
    skeletonTitleWidth: "8.125rem",
    skeletonTitleHeight: "1.125rem",
    skeletonSubtextWidth: "6.25rem",
    skeletonSubtextHeight: "0.75rem",
  },
  md: {
    letters: "nuco-typography--subtitle",
    title: "nuco-typography--body bold",
    subtext: "nuco-typography--subtitle light",
    skeletonImageSize: "2.5rem",
    skeletonTitleWidth: "8.125rem",
    skeletonTitleHeight: "1.3125rem",
    skeletonSubtextWidth: "6.25rem",
    skeletonSubtextHeight: "1.125rem",
  },
  lg: {
    letters: "nuco-typography--subtitle",
    title: "nuco-typography--h4 bold",
    subtext: "nuco-typography--subtitle light",
    skeletonImageSize: "3rem",
    skeletonTitleWidth: "9.375rem",
    skeletonTitleHeight: "1.5rem",
    skeletonSubtextWidth: "7.5rem",
    skeletonSubtextHeight: "1.125rem",
  },
  xl: {
    letters: "nuco-typography--h4",
    title: "nuco-typography--h4 bold",
    subtext: "nuco-typography--subtitle light",
    skeletonImageSize: "3.5rem",
    skeletonTitleWidth: "9.375rem",
    skeletonTitleHeight: "1.5rem",
    skeletonSubtextWidth: "7.5rem",
    skeletonSubtextHeight: "1.125rem",
  },
  "2xl": {
    letters: "nuco-typography--h4",
    title: "nuco-typography--h4 bold",
    subtext: "nuco-typography--subtitle light",
    skeletonImageSize: "4rem",
    skeletonTitleWidth: "9.375rem",
    skeletonTitleHeight: "1.5rem",
    skeletonSubtextWidth: "7.5rem",
    skeletonSubtextHeight: "1.125rem",
  },
};
